import { Injectable } from '@angular/core';

@Injectable()
export class UpdateLocalService {
  constructor() {

  }

  public static getMeasuresLastUpdate(): string {
    return localStorage.getItem('measuresLastUpdate');
  }

  public static setMeasuresLastUpdate(measuresLastUpdate: string): void {
    localStorage.setItem('measuresLastUpdate', measuresLastUpdate)
  }

  public static getObservationTypesLastUpdate(): string {
    return localStorage.getItem('observationTypesLastUpdate');
  }

  public static setObservationTypesLastUpdate(observationTypesLastUpdate: string): void {
    localStorage.setItem('observationTypesLastUpdate', observationTypesLastUpdate);
  }

  public static getPksLastUpdate(): string {
    return localStorage.getItem('pksLastUpdate');
  }

  public static setPksLastUpdate(pksLastUpdate: string): void {
    localStorage.setItem('pksLastUpdate', pksLastUpdate);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/local-data-services/update-local.service.ts